export const enum YesNo {
  Yes = 'Yes',
  No = 'No',
}


export const YesNoToBoolean = {
  [YesNo.Yes]: true,
  [YesNo.No]: false,
};
